// extracted by mini-css-extract-plugin
export var divider = "_3j-0";
export var dividerText = "_3j-1";